import { BotButtonPayloadType, IOpenUrlPayload } from '@gem/models/botModel';

export class OpenUrlButtonPayload {
  type: BotButtonPayloadType;
  url: string;

  constructor(data: IOpenUrlPayload) {
    this.type = data.type;
    this.url = data.url;
  }

  toJSON(): IOpenUrlPayload {
    return {
      type: this.type,
      url: this.url,
    };
  }
}
